import { initialize } from "launchdarkly-js-client-sdk";

let client = null;
let readyPromise = Promise.resolve();

function init({ clientKey, context, options } = {}) {
  if (client) return readyPromise;
  if (!clientKey) return readyPromise;
  
  const ctx = context || { kind: "user", key: "anonymous-user-key", name: "anonymous" };
  client = initialize(clientKey, ctx, { bootstrap: "localStorage", ...options });
  readyPromise = client.waitForInitialization().catch(() => { /* Would be handled in ATW-22619 */ });
  return readyPromise;
}

function featureEnabled(flagName, fallback = false) {
  if (!client) return fallback;
  try {
    return client.variation(flagName, fallback);
  } catch {
    return fallback;
  }
}

function ready() {
  return readyPromise;
}

export default { init, featureEnabled, ready };
